<template>
  <div id="dynamic-lsit" class="flex-column">
    <Title/>
    <div class="listContainer flex-column-1">
    	<mt-loadmore id="ZXXXLB" ref="loadMore"  style="min-height: 100%;" :top-method="loadTop" :bottom-method="loadBottom" :autoFill="true" :bottom-all-loaded="allLoaded">
      <div class="noNotice" v-if="noticeList.length == 0">
        <img :src="require('@/assets/imgs/dynamic/noNotice.png')" alt>
        <p>暂无消息</p>
      </div>

      <ul style="height: 100%;">
        <router-link tag="li" :to="{name:'dynamic-detail',params:{id:1},query:{id:item.id}}" class="noticeItem" v-for="(item,index) in noticeList" :key="index">
          <div class="img-box">
          	<img class="cover" :src="item.titleImageUrl" alt>
          </div>
          <p class="title">{{item.title}}</p>
          <div>
            <span class="date">{{item.modifiedTime}}</span><span class="tag icon iconfont icon-arrowRight"></span>
          </div>
          <div>
            <span class="date" v-if="getTime(item.activityEndTime)">活动已过期</span>
            <span class="date" v-if="!getTime(item.activityEndTime)&&item.type == 2">活动进行中</span>
          </div>
          <div>
          	<span class="date" v-if="item.type == 2">{{item.activityBeginTime}} 到  {{item.activityEndTime}}</span>
          </div>
        </router-link>
      </ul>
      <div slot="top" class="mint-loadmore-top">
	      <img style="height:65px;width:100%" src="../../../assets/imgs/home/otmsLoading.gif" alt="" />
	    </div>
	    <div class="more_loadings">
				<span v-if="allLoaded">这是我的底线啦!!!</span>
			</div>
			<div slot="bottom" class="mint-loadmore-bottom">
	      <span v-if="!allLoaded">加载更多</span>
	    </div>
      </mt-loadmore>
    </div>
    <NavbarFooter/>                    
  </div>
</template>
<script>
import { Loadmore,Toast } from 'mint-ui'
import {GET_APPLET_MESSAGE_LIST} from '@/assets/configs/api/yuanqu'
export default {
  name: "dynamicList",
  data() {
    return {
      noticeList: [],
      allLoaded:false,
      allData:false,
      pageNum:1
    }
  },
  filters : {
  	dataCut (val) {
  		try{
  			return val.split(" ")[0]
  		}catch(e){
  			//TODO handle the exception
  		}
  	}
  },
  methods : {
  	getTime(time){
  		if(time){
  			var date = time
				date = date.substring(0,19)  
				date = date.replace(/-/g,'/')
				var timestamp = new Date(date).getTime()
				
				var nowtimestamp = Date.parse(new Date())
				if(nowtimestamp-timestamp>0){
					return true
				}else{
					return false
				}
  		}
  		
  	},
  	getData(status){
  		if(status == "reLoad"){
  			this.pageNum = 1
  		}
  		let config = {
  			headers:{
  				'Content-Type':'application/json'
  			}
  		}
  		this.$post(GET_APPLET_MESSAGE_LIST,
					{
						parkCode:sessionStorage.getItem("parkCode"),
						pageNum:this.pageNum,
						pageSize:3
					},
					data => {
						if(status == "reLoad"){
			  			this.noticeList = []
			  		}
						this.$refs.loadMore.onBottomLoaded(this.$refs.loadMore.$el.id)
						this.allLoaded = false
//						console.log(data.list.length)
						if(data.list.length==3){
							this.pageNum += 1
						}else{
							this.allLoaded = true
						}
						if(data.list.length != 0){
							data.list.forEach( item => {
								this.noticeList.push(item)
							})
						}
					},
	        error => {
	        	
	        },config
	      )
  	},
		loadTop () {
			this.getData("reLoad")
		},
		loadBottom () {
			this.getData()
		}
	},
	mounted() {
		this.getData ()
	}
};

</script>
<style lang="scss" scoped>
#dynamic-lsit{
	.listContainer {
	  padding: 0 4px;
	  .noNotice {
	    position: absolute;
	    top: 50%;
	    left: 50%;
	    transform: translate3d(-50%, -50%, 0);
	    img {
	      display: block;
	    }
	    p {
	      text-align: center;
	      font-weight: 400;
	      margin: 26px;
	      color: rgba(89, 137, 214, 1);
	    }
	  }
	
	  .noticeItem {
	    margin-bottom: 28px;
	    .title {
	      font-size: 16px;
	      font-weight: 500;
	      color: rgba(51, 51, 51, 1);
	      margin: 10px 0 8px 14px;
	    }
	    .date {
	      color: rgba(155, 155, 155, 1);
	      margin-left: 14px;
	      font-size:14px;
	    }
	    .tag {
	      color: rgba(155, 155, 155, 1);
	      float: right;
	      font-size:14px;
	      margin-right: 16px;
	    }
	    .img-box{
	    	display: flex;
	    	width:100%;
	    	height:4rem;
	    	overflow: hidden;
	    	
	    	img{
	    		width:100%;
	    	}
	    }
	  }
	}
	.more_loadings{
		text-align: center;
	}
}

</style>
